import { HXCircleIcon, KnowYourDueDateMweb, KnowYourDueDateWeb } from "@aph/ui-lib-humanx";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { HOME_TYPE } from "@/components/PageHome/api/interface";
import OnboardingFlow from "@/components/PageHome/components/OnboardingSection/Modals/OnboardingFlow";
import currentFlowSelector from "@/components/PageHome/redux/selectors/currentFlow";
import { setCurrentFlow } from "@/components/PageHome/redux/slice";
import { NON_ONBOARDED_STATUS } from "@/helpers/constants";
import routes from "@/helpers/router";
import { buttonClickedEvent } from "@/helpers/TSDEvents";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import signedInStateSelector from "@/redux/slice/auth/selectors/signedInState";
import userOnboardedSelector from "@/redux/slice/auth/selectors/userOnboarded";
import styles from "./SecondFold.module.scss";

const SecondFold = ({ deviceType, data, categorySlug, isPharma = false }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const router = useRouter();
  const currentFlow = useAppSelector(currentFlowSelector);
  const dispatch = useAppDispatch();
  const signedInStatus = useAppSelector(signedInStateSelector);
  const userOnBoarded = useAppSelector(userOnboardedSelector);
  const ctaText = "Calculate now";

  const getFlowName = (category: string) => {
    if (category === "pregnancy") {
      return HOME_TYPE.PREGNANCY;
    } else if (category === "preconception") {
      return HOME_TYPE.PRECONCEPTION;
    } else if (category === "postpartum") {
      return HOME_TYPE.BIRTH;
    } else if (category === "newborn-and-infant") {
      return HOME_TYPE.NEW_MOM;
    } else {
      return null;
    }
  };

  const handleCtaClick = () => {
    buttonClickedEvent({
      button_name: ctaText,
      screen_name: "Category Page",
      momverse_stage: NON_ONBOARDED_STATUS,
      is_loggedin: signedInStatus === SignedinState.SIGNEDIN ? true : false,
    });
    const newFlow = getFlowName(categorySlug);

    dispatch(setCurrentFlow(newFlow));
    setIsModalOpen(true);
  };

  const handleModelOpen = () => {
    setIsModalOpen(false);
    router.push(routes.home);
  };

  const nudgeProps = {
    title: data?.Nudge,
    description: data?.Nudge,
    ctaText: ctaText,
    onCtaClick: handleCtaClick,
  };

  return (
    <div className={`container spacingBetweenSections`}>
      <div className={`${styles.nudgeCardRoot} ${userOnBoarded ? styles.textCenter : ""}`}>
        <HXCircleIcon iconStyle="style2" className={styles.bgIcon} />
        <div className={styles.left}>
          {data?.Title && <div className={styles.title} dangerouslySetInnerHTML={{ __html: data?.Title }}></div>}
          {data?.Description && (
            <div className={styles.description} dangerouslySetInnerHTML={{ __html: data?.Description }}></div>
          )}
        </div>
        {!userOnBoarded && categorySlug !== "postpartum" && (
          <>
            {!isPharma && (<div className={styles.right}>
              {deviceType?.isMobile && <KnowYourDueDateMweb {...nudgeProps} />}
              {deviceType?.isDesktop && <KnowYourDueDateWeb {...nudgeProps} />}
            </div>)}
            <OnboardingFlow
              isOpen={isModalOpen}
              currentFlow={currentFlow}
              onClose={() => setIsModalOpen(false)}
              handleModelOpen={handleModelOpen}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SecondFold;
